// extracted by mini-css-extract-plugin
module.exports = {"Container":"CommunityShotContainer_Container__JW_Ed"};